<template>
  <v-text-field mclass="text-caption" ref="textField"
                v-model="search"
                :placeholder="placeholder"
                hide-details
                clearable
                single-line
                rounded filled prepend-inner-icon="mdi-magnify"
                dense
                @input="keyDown"/>
</template>

<script>
export default {
  name: 'Search',
  props: {
    value: {type:String,required:false},
    placeholder: {type:String,required:false}
  },
  data() {
    return {
      search: this.value,
      timerId: null
    }
  },
  watch: {
    value(newValue) {
      this.search = newValue;
    }
  },
  mounted () {
    document.onkeydown = e => {
      e = e || window.event
      if (e.keyCode === 191 && /* Forward Slash '/' */ e.target !== this.$refs.textField.$refs.input && !this.$store.state.disableSearchHotKey) {
        e.preventDefault()
        this.$nextTick(() => {
          this.$refs.textField.focus()
        });
      }
    }
  },
  beforeDestroy() {
    document.onkeydown = null
  },
  methods: {
    keyDown() {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.valueChanged()
      }, 500);
    },
    valueChanged() {
      this.$emit('input', this.search);
      this.$emit('change', this.search);
    },
  }
}

</script>
